import React from "react";
import FilterChipBar from "./FilterChipBar";
import styles from "./ExploreTopBar.module.scss";

/**
 * 모바일/태블릿 상단바
 *
 * 피그마: 104px 높이 = 56px 네비게이션 + 48px 필터 칩 바
 * 네비게이션: 뒤로가기 + "disco 매물" 타이틀 + 검색 아이콘
 *
 * @param {Object} props
 * @param {Function} props.onBack        — 뒤로가기
 * @param {Function} props.onSearch      — 검색 아이콘 클릭
 * @param {Object}   props.payload       — 필터 상태
 * @param {Function} props.onFullFilter  — 전체필터 열기
 * @param {Function} props.onChipClick   — 개별 필터 칩 클릭
 * @param {Function} props.onReset       — 필터 초기화
 */
const ExploreTopBar = ({
  onBack,
  onSearch,
  payload,
  onChange,
  onFullFilter,
  onChipClick,
  onReset,
}) => {
  return (
    <div className={styles.container}>
      {/* 네비게이션 바 */}
      <div className={styles.navBar}>
        <button type="button" className={styles.navBtn} onClick={onBack}>
          <ChevronLeftIcon />
        </button>
        <div className={styles.title}>
          <span className={styles.logo}>disco</span>
          <span className={styles.titleText}>매물</span>
        </div>
        <button type="button" className={styles.navBtn} onClick={onSearch}>
          <SearchIcon />
        </button>
      </div>

      {/* 필터 칩 바 */}
      <FilterChipBar
        payload={payload}
        onChange={onChange}
        onFullFilter={onFullFilter}
        onChipClick={onChipClick}
        onReset={onReset}
      />
    </div>
  );
};

// ── 아이콘 ──

const ChevronLeftIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SearchIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 21l-4.35-4.35M19 11a8 8 0 11-16 0 8 8 0 0116 0z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ExploreTopBar;
